import { StressAndStabilityInPort } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { valueAsNumber } from "../ParsingUtils";
import PropTransformer from "../PropTransformer";
import StringToNumberPropTransformer from "../StringToNumberPropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const STRESS_AND_STABILITY_IN_PORT_DATA_TAG = 'DraftInPort';
class OldDraftTransformer extends PropTransformer {
    toGateway() {
        return undefined;
    }
    fromGateway(draft) {
        const draftAsNumber = valueAsNumber(draft);
        if (draftAsNumber) {
            return { draftForward: draftAsNumber };
        }
        return {};
    }
}
class OldFrameTransformer extends PropTransformer {
    toGateway() {
        return undefined;
    }
    fromGateway(frame) {
        const frameAsNumber = valueAsNumber(frame);
        if (frameAsNumber) {
            return { draftMeasurementPositionForward: frameAsNumber };
        }
        return {};
    }
}
export default class StressAndStabilityInPortParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.IN_PORT_STRESS_AND_STABILITY, FIXED_PROTOCOL_CONTENT_TYPE_IDS.IN_PORT_STRESS_AND_STABILITY, STRESS_AND_STABILITY_IN_PORT_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            portName: 'portName',
            draft: new OldDraftTransformer(),
            draftForward: 'draftForward',
            draftMidship: 'draftMidship',
            draftAft: 'draftAft',
            frame: new OldFrameTransformer(),
            draftMeasurementPositionForward: 'draftMeasurementPositionForward',
            draftMeasurementPositionMidship: 'draftMeasurementPositionMidship',
            draftMeasurementPositionAft: 'draftMeasurementPositionAft',
            waterDensity: 'waterDensity',
            gzCurve: 'gzCurve',
            rightingLeverGz: 'rightingLeverGz',
            gm: new StringToNumberPropTransformer('gm'),
            shearForces: new StringToNumberPropTransformer('shearForces'),
            bending: 'bending',
            torsion: new StringToNumberPropTransformer('torsion'),
            loadlineZone: 'loadlineZone',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new StressAndStabilityInPort(props.portName, props.draftForward, props.draftMidship, props.draftAft, props.draftMeasurementPositionForward, props.draftMeasurementPositionMidship, props.draftMeasurementPositionAft, props.waterDensity, props.gzCurve, props.rightingLeverGz, props.gm, props.shearForces, props.bending, props.torsion, props.loadlineZone, props.freeText);
    }
}
//# sourceMappingURL=StressAndStabilityInPortParser.js.map